<template>
  <section class="content">
    <div class="col-xs-12 text-center" v-if="!tableList.id">
      <p>此店家無桌位！</p>
    </div>
    <div class="col-xs-12" v-if="tableList.id">
      <p>桌位設定ID：{{tableList.id}}</p>
      <p>桌位建立時間：{{tableList.create_time}}</p>
    </div>
    <div class="col-xs-12" v-if="tableList.id">
      <div class="col-xs-12" v-for="floor in tableList.item_list">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th>{{floor.name}} ({{floor.id}})
              <span class="pull-right">pos table_id：{{floor.vendor_custom_id}}</span>
            </th>
          </tr>
          </thead>
          <tbody>
            <tr role="row" class="even">
              <td>
                <div class="col-xs-12 col-md-6">
                  <p>排序：{{floor.sort}}</p>
                  <p>前端顯示：
                    <span v-if="floor.is_visible" class="label label-success">顯示</span>
                    <span v-if="!floor.is_visible"  class="label label-danger">不顯示</span>
                  </p>
                </div>
                <div class="col-xs-12 col-md-6">
                  <p>暫停使用：
                    <span v-if="!floor.is_suspend" class="label label-success">正常</span>
                    <span v-if="floor.is_suspend"  class="label label-danger">暫停</span>
                  </p>
                  <p>使用狀況：
                    <span v-if="!floor.is_available" class="label label-success">無人</span>
                    <span v-if="floor.is_available"  class="label label-danger">使用中</span>
                  </p>
                </div>
              </td>
            </tr>
            <tr role="row">
              <div class="inline-block table-block" v-for="table in floor.child_list">
                <h4 class="text-center text-600 table-header">{{table.name}} ({{table.id}})</h4>
                <div class="word-block">
                  <p>
                    pos table_id：{{table.vendor_custom_id}}
                  </p>
                  <p>
                    排序：{{table.sort}}
                  </p>
                  <p>
                    前端顯示：
                    <span v-if="table.is_visible" class="label label-success">顯示</span>
                    <span v-if="!table.is_visible"  class="label label-danger">不顯示</span>
                  </p>
                  <p>暫停使用：
                    <span v-if="!table.is_suspend" class="label label-success">正常</span>
                    <span v-if="table.is_suspend"  class="label label-danger">暫停</span>
                  </p>
                  <p>使用狀況：
                    <span v-if="!table.is_available" class="label label-success">無人</span>
                    <span v-if="table.is_available"  class="label label-danger">使用中</span>
                  </p>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
        <br>
      </div>
      <!--
      <div class="col-xs-12 col-md-3 p-10 text-center" v-if="show.category">
        <h4 class="text-red">停賣分類</h4>
        <div class="col-xs-12">
          <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
            <tbody>
            <tr class="even" role="row" v-for="(category, index) in disTableList.category">
              <td>
                {{index + 1}}
              </td>
              <td>
                {{category.name}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      -->
    </div>
  </section>
</template>
<script>
export default{
  props: ['storeId'],
  data () {
    return {
      tableList: {
        id: '',
        create_time: '',
        item_list: []
      }
    }
  },
  methods: {
    getTableSetting () {
      this.tableItemList = []
      var self = this
      var url = '/store/' + this.storeId + '/tableSetting'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tableSetting = response.data.setting
          if (tableSetting) {
            self.tableList.id = tableSetting.id
            self.tableList.create_time = tableSetting.create_time
            self.tableList.item_list = tableSetting.item_list
          } else {
            self.tableList = {
              id: '',
              create_time: '',
              item_list: []
            }
          }
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    storeId () {
      this.getTableSetting()
    }
  }
}
</script>
<style lang="sass" scoped>
.table-bordered
  border: 2px solid #222d32
.text-600
  font-weight: 600
.table-block
  margin: 10px
  border: 2px solid #222d32
  .table-header
    background: #222d32
    color: white
    padding: 2px 0px
    margin-top: 0px
  .word-block
    padding: 0px 10px
</style>



// WEBPACK FOOTER //
// TableSettingTemp.vue?76541744